import debounce from "lodash.debounce";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from "body-scroll-lock";

const mobileMixin = {
  data() {
    return {
      onResize: null,
      mounted: false
    };
  },
  created() {
    this.onResize = debounce(() => this.detectMobile(), 500);
  },
  mounted() {
    this.mounted = true;
    this.detectMobile();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    if (this.mobile) clearAllBodyScrollLocks();
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    openMobile() {
      disableBodyScroll(this.multiselect().list);
      this.adjustMobileListHeight();
    },
    closeMobile() {
      enableBodyScroll(this.multiselect().list);
      this.resetMobileListHeight();
    },
    detectMobile() {
      this.mobile =
        typeof window !== "undefined" &&
        !window.matchMedia("(min-width: 768px)").matches;
      this.fullscreen = this.desktopFullscreen || this.mobile;
    },
    adjustMobileListHeight() {
      if (!this.mobile || this.mobileListHeightAdjusted) return;

      //Input field height
      const inputHeight = 61;

      // Default list height for non iOS devices
      let height = `calc(100% - ${inputHeight}px)`;

      // iOS does not account for virtuel keyboard
      // in viewport height, hence:
      if (this.iOS()) {
        // iOS version > 13
        const visualViewport = this.visualViewport();
        if (visualViewport) {
          height = `${visualViewport.height - inputHeight}px`;
        } else {
          // Conservatively assume 40% of vh available
          height = `calc(-${inputHeight}px + 40%)`;
        }
      }

      this.multiselect().list.style.height = height;
    },
    resetMobileListHeight() {
      this.multiselect().list.style.height = "auto";
      this.mobileListHeightAdjusted = false;
    },
    iOS() {
      return navigator.userAgent.match(/iphone|ipod|ipad/i);
    },
    visualViewport() {
      return typeof window !== "undefined" && window.visualViewport;
    }
  }
};

export default mobileMixin;
